import { BaseApi } from './base.api.js';

export class SecurityMeasureApi extends BaseApi {
    constructor(client) {
        super(client, '/security-measure');
    }
}
